import request from 'supertest'
import { app } from '@/infra/app'
import { prismaService as prisma } from '@/infra/database/prisma'
import { OriginFactory } from '../../../../../test/factories/makeOrigin'

describe('Delete Origin By Name (E2E)', () => {
  let originFactory: OriginFactory
  beforeEach(async () => {
    originFactory = new OriginFactory(prisma)
  })

  test('[DELETE] /origins?=originName=Test e2e', async () => {
    await Promise.all([
      originFactory.makePrismaOrigin({
        name: 'Test e2e'
      }),
    ])

    const response = await request(app)
    .delete('/origins?originName=Test e2e')
    .set('Authorization', `Bearer F5D9`)
    .send()

    expect(response.status).toBe(204)

    const originDoesNotExists = await prisma.origin.count()
    expect(originDoesNotExists).toBe(0)
  })
  afterEach(async () => {
    await prisma.origin.deleteMany()
  })
})